import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AuthviewHeaderComponent} from './authview-header/authview-header.component';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatMenuModule} from '@angular/material/menu';
import {MatIconModule} from '@angular/material/icon';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatButtonModule} from '@angular/material/button';
import {MatBadgeModule} from '@angular/material/badge';
import {MatDividerModule} from '@angular/material/divider';
import {RouterModule} from '@angular/router';
import {MatCardModule} from '@angular/material/card';
import {MatChipsModule} from '@angular/material/chips';
import {MatFormFieldModule, MatHint} from '@angular/material/form-field';
import {DropzoneCdkModule} from '@ngx-dropzone/cdk';
import {DropzoneMaterialModule} from '@ngx-dropzone/material';
import {RelativeTimePipe} from './_pipes/relative-time.pipe';
import {ConfirmationDialogComponent} from './confirmation-dialog/confirmation-dialog.component';
import {MatCheckbox} from '@angular/material/checkbox';
import {MatDialogModule} from '@angular/material/dialog';
import {MatInput, MatInputModule} from '@angular/material/input';
import {MatAutocompleteModule, MatOption} from '@angular/material/autocomplete';
import {MatSelect} from '@angular/material/select';
import {CustomToggleGroupComponent} from './custom-toggle-group/custom-toggle-group.component';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {HeaderCommunitySelectorComponent} from './header-community-selector/header-community-selector.component';
import {UserInfoComponent} from './user-info/user-info.component';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {UserAvatarDirective} from '../_directives/user-avatar.directive';
import {BadgeProgressComponent} from './badge-progress/badge-progress.component';
import {TabSelectorComponent} from './tab-selector/tab-selector.component';
import {MatTabsModule} from '@angular/material/tabs';
import {CustomRouterLinkActiveDirective} from '../_directives/custom-router-link-active.directive';
import {CreatePollComponent} from './create-poll/create-poll.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {PollViewComponent} from './poll-view/poll-view.component';
import {MatRadioModule} from '@angular/material/radio';
import {HeaderNotificationsComponent} from './header-notifications/header-notifications.component';
import {HideGiphyOverlayDirective} from '../_directives/hide-giphy-overlay.directive';
import {ScrollIntoViewDirective} from '../_directives/scroll-into-view.directive';
import {UserNamePipe} from './_pipes/user-name.pipe';
import {RemoveEmojisPipe} from './_pipes/remove-emojis.pipe';
import {TimePickerComponent} from './time-picker/time-picker.component';
import {NotificationsListComponent} from './notifications-list/notifications-list.component';
import {PostsListComponent} from './posts-list/posts-list.component';
import {MatTableModule} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {MatExpansionModule} from "@angular/material/expansion";
import {DragDropModule} from "@angular/cdk/drag-drop";
import {RegisterComponent} from './register/register.component';
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {MatStep, MatStepLabel, MatStepper, MatStepperNext} from "@angular/material/stepper";
import {PasswordValidatorComponent} from "./password-validator/password-validator.component";
import {OnboardingQuestionsComponent} from './onboarding-questions/onboarding-questions.component';
import {CommunityDynamicPageComponent} from './community-dynamic-page/community-dynamic-page.component';
import {ImageCropperComponent} from "ngx-image-cropper";
import {HeatmapComponent} from './heatmap/heatmap.component';
import {AttachmentsComponent} from './attachments/attachments.component';
import {ColorPickerModule} from 'ngx-color-picker';
import {HeatmapVoteComponent} from './heatmap-vote/heatmap-vote.component';
import {HeatmapVoteResultsComponent} from './heatmap-vote-results/heatmap-vote-results.component';
import {CreateHeatmapComponent} from './create-heatmap/create-heatmap.component';
import {AutofillDirective} from '../_directives/auto-fill.directive';
import {StepperWatcherDirective} from '../_directives/stepper-watcher.directive';
import {TextLightboxComponent} from './text-lightbox/text-lightbox.component';
import {EmailVerifiedComponent} from './email-verified/email-verified.component';
import {MatList, MatListItem, MatListItemTitle} from '@angular/material/list';
import {FooterComponent} from './footer/footer.component';
import {ProfileQuestionsComponent} from './profile-questions/profile-questions.component';
import {IframeTrackerDirective} from "../_directives/iframe-click-tracker.directive";
import {CustomButtonColoursDirective} from "../_directives/custom-button-colours.directive";
import {PollembedComponent} from './pollembed/pollembed.component';
import {NestedOptionComponent} from './poll-view/nested-option/nested-option.component';
import {RecentActivityComponent} from './recent-activity/recent-activity.component';
import {DateAgoPipe} from "../_pipes/date-ago.pipe";
import {NotificationRoundPipe} from "../_pipes/notification-round.pipe";
import {TruncatedTooltipDirective} from "../_directives/truncated-tooltip.directive";
import {MatSliderModule} from "@angular/material/slider";
import {AudioPlayerComponent} from "./audio-player/audio-player.component";
import {CountAnimationDirective} from "../_directives/count-animation.directive";


const components = [
    AuthviewHeaderComponent,
    ConfirmationDialogComponent,
    UserAvatarDirective,
    UserInfoComponent,
    BadgeProgressComponent,
    TabSelectorComponent,
    CustomRouterLinkActiveDirective,
    HideGiphyOverlayDirective,
    ScrollIntoViewDirective,
    PasswordValidatorComponent,
    HeatmapComponent,
    AttachmentsComponent,
    CreateHeatmapComponent,
    AutofillDirective,
    StepperWatcherDirective,
    EmailVerifiedComponent,
    FooterComponent,
    IframeTrackerDirective,
    CustomButtonColoursDirective
];

const modules = [
    MatToolbarModule,
    MatMenuModule,
    MatIconModule,
    ReactiveFormsModule,
    MatTooltipModule,
    MatButtonModule,
    MatBadgeModule,
    MatDividerModule,
    RouterModule,
    MatCardModule,
    MatChipsModule,
    MatHint,
    FormsModule,
    MatFormFieldModule,
    DropzoneCdkModule,
    DropzoneMaterialModule,
    RelativeTimePipe,
    MatButtonToggleModule,
    MatInputModule,
    MatAutocompleteModule,
    MatProgressBarModule,
    MatTabsModule,
    MatDatepickerModule,
    MatRadioModule,
    UserNamePipe,
    RemoveEmojisPipe
]

@NgModule({
    declarations: [
        ...components,
        CustomToggleGroupComponent,
        HeaderCommunitySelectorComponent,
        CreatePollComponent,
        PollViewComponent,
        HeaderNotificationsComponent,
        TimePickerComponent,
        NotificationsListComponent,
        PostsListComponent,
        RegisterComponent,
        OnboardingQuestionsComponent,
        CommunityDynamicPageComponent,
        HeatmapVoteComponent,
        HeatmapVoteResultsComponent,
        TextLightboxComponent,
        ProfileQuestionsComponent,
        PollembedComponent,
        NestedOptionComponent,
        RecentActivityComponent,
        DateAgoPipe,
        AudioPlayerComponent
    ],
    imports: [
        CommonModule,
        ...modules,
        MatCheckbox,
        MatDialogModule,
        MatInput,
        MatOption,
        MatSelect,
        MatTableModule,
        MatPaginator,
        MatExpansionModule,
        DragDropModule,
        MatProgressSpinner,
        MatStep,
        MatStepper,
        MatStepperNext,
        ImageCropperComponent,
        ColorPickerModule,
        MatList,
        MatListItem,
        MatListItemTitle,
        MatStepLabel,
        NotificationRoundPipe,
        TruncatedTooltipDirective,
        CountAnimationDirective,
        MatSliderModule,
    ],
    exports: [
        ...components,
        ...modules,
        CustomToggleGroupComponent,
        CreatePollComponent,
        PollViewComponent,
        TimePickerComponent,
        RegisterComponent,
        HeatmapVoteComponent,
        RecentActivityComponent,
        AudioPlayerComponent,
        ProfileQuestionsComponent,
    ]
})
export class SharedModule {
}
